import React from 'react';
import { cssMap } from '@atlaskit/css';

const styles = cssMap({
	container: { display: 'inline-grid', position: 'relative', minWidth: 0, maxWidth: '100%' },
	reservation: { visibility: 'hidden', whiteSpace: 'nowrap' },
	title: {
		position: 'absolute',
		inset: 0,
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
	},
});

export const isAuraWorkflowByline = (appId: string): boolean =>
	appId ===
	'ari:cloud:ecosystem::extension/483ca206-b4d2-4ffd-9323-a9ca37e4eeea/4a41da34-9d6c-453e-b1eb-f41bd3f13d1e/static/workflow-byline-item';

/** Preserve the initial label width without discarding live workflow status updates. */
export const StableBylineAppTitle = ({
	title,
	initialTitle,
}: {
	title: string;
	initialTitle: string;
}): React.JSX.Element => (
	<span css={styles.container}>
		<span css={styles.reservation} aria-hidden="true">
			{initialTitle}
		</span>
		<span css={styles.title} title={title}>
			{title}
		</span>
	</span>
);
